// has number
const hasNumber = (number) => new RegExp(/[0-9]/).test(number);

// has mix of small and capitals
const hasMixed = (number) =>
  new RegExp(/[a-z]/).test(number) && new RegExp(/[A-Z]/).test(number);

// has special chars
const hasSpecial = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);

// set color based on password strength
export const strengthColor = (count) => {
  if (count < 2)
    return { label: "Muito fraca", color: "error", textColor: "red" };
  if (count < 3)
    return { label: "Fraca", color: "warning", textColor: "orange" };
  if (count < 4)
    return { label: "Normal", color: "primary", textColor: "green" };
  if (count < 5)
    return { label: "Forte", color: "primary", textColor: "green" };
  if (count < 6)
    return { label: "Muito forte", color: "primary", textColor: "green" };
  return { label: "Muito fraca", color: "error", textColor: "red" };
};

// password strength indicator
export const strengthIndicator = (number) => {
  return (
    number.length > 5 &&
    hasNumber(number) &&
    hasSpecial(number) &&
    hasMixed(number)
  );
};

export const strengthChecker = (number) => {
  let strengths = {
    length: false,
    number: false,
    letters: false,
    special: false,
  };
  if (number.length >= 6) strengths.length = true;
  if (hasNumber(number)) strengths.number = true;
  if (hasMixed(number)) strengths.letters = true;
  if (hasSpecial(number)) strengths.special = true;
  return strengths;
};
